import React from 'react';
import ContactStyle from './contactStyle';

import normal from '../../files/nishant arora resume.pdf'
import EuroPass from '../../files/CV-Europass-20200222-Arora-EN.pdf'

import contact from '../../img/contact.png'

const Contacts = () => {
    return (
        <div className="container contact">
           <div className="row align-items-center">
               <div className="col-12 col-lg-6">
                   <img src={contact} className="img-fluid contactIcon" alt="contact"/>
                   <p className="contactHeading text-white pt-3">Let's get in touch</p>
                   <div className="mt-3 mt-lg-5 pt-lg-4">
                       <a href={normal} download className="btn DownloadBtn mr-3">Download CV</a>
                       <a href={EuroPass} download  className="btn DownloadBtn">Download Europass CV</a>
                   </div>
               </div>
               <div className="col-12 col-lg-6 mt-5 mt-lg-0">
                   <a className="contactContent" href="mailto: na88277@gmail.com"><p>
                       na88277@gmail.com
                   </p></a>
                   <a className="contactContent" href="tel: +91 8827731259"><p className="pt-3">
                       +91 8827731259
                   </p></a>
               </div>
           </div>
            <ContactStyle />
        </div>
    );
};

export default Contacts;
